/**
 * SlxControls 1.2.41 ({@link https://www.selerix.com})
 * This is unpublished proprietary source code of Selerix Systems, Inc. The
 * copyright notice above is not evidence any actual or intended
 * publication of such source code.
 * @copyright Copyright 2025 Selerix Systems, Inc. All Rights Reserved.
 */
(function (global) {
	'use strict';
	var x = global.SlxControl;

	// event keys
	var EVENTS = {
		click: 'click.slx.ac',
		keydown: 'keydown.slx.ac',
		scroll: 'scroll.slx.ac',
		change: 'change.slx.ac',
		keyup: 'keyup.slx.ac',
		focus: 'focus.slx.ac',
		focusout: 'focusout.slx.ac',
		resize: 'resize.slx.ac'
	};

	/**
	 * slx.autocomplete
	 * @requires slx.core
	 */
	x.slx.autocomplete = function () {
		var that = this;
		x.slx.base.apply(that, arguments);

		// reference current element
		var el = that._element;
		if (el === void 0) { return this; }
		else if (el.length === 0) { return el; }

		// set custom settings from data props and attributes
		that.id = that.id || el.slxUniqueId();
		that.selector = '#' + that.id;
		that.items = that.items || [];
		if (that.highlight === void 0) { that.highlight = el.data('highlight') === false ? false : true; }
		that.container = x(that.selector + '_container');
		if (!that.container.length) { that.container = el.closest('.input-group'); }
		that.service = that.service || el.data('service') || null;
		that.dropDownHeight = that.dropDownHeight || el.data('dropdownheight') || null;
		that.showArrow = that.showArrow || el.data('showarrow');
		that.template = that.template || that.container.find('.slx-autocomplete-template').html() || null;
		that.templateID = that.templateID || el.data('templateid') || null;
		that.onChange = typeof that.onChange === 'function' ? that.onChange : el.attr('onchange') !== void 0 ? x.eval.call(el[0], el.attr('onchange'), 'event') : void 0;
		that.placeholder = that.placeholder || el.attr('placeholder') || el.data('placeholder') || '';
		that.searchParameters = that.searchParameters || el.data('search-parameters') || null;

		// check for search parameters containing JS object as string
		if (typeof that.searchParameters === 'string') {
			if (/^\{+([\s\S]{3,})+\}$/g.test(that.searchParameters)) {
				try {
					that.searchParameters = x.eval('return ' + that.searchParameters)();
				} catch {
					that.searchParameters = null;
				}
			} else {
				that.searchParameters = null;
			}
		}

		// check for match requirement
		if (that.requireMatch === void 0) {
			that.requireMatch = el.data('require-match');
			if (that.requireMatch === void 0 || that.requireMatch === null) {
				that.requireMatch = true;
			}
		}

		// check for template
		if (that.templateID !== null) {
			var t = x('#' + that.templateID);
			if (!t.hasClass('slx-autocomplete-template')) { t.addClass('slx-autocomplete-template'); }
			that.template = t.html();
		}

		// local flags
		var _filtered = null;
		var _label = x('label[for="' + that.id + '"]');

		// hidden value field
		var _hidden = this.container.find(that.selector + '_value');
		if (_hidden.length === 0) { _hidden = x(that.selector + '_value'); }

		// get and set value
		that.value = function (v) {
			if (v === void 0) {
				// get value
				return _hidden.slxVal();
			} else {
				// set value
				var item = that.selectedItem() || v;
				var selectedText = _itemText(item);
				var ischange = (v !== null && v.toString() !== (_hidden.slxVal() || '')) || (el.slxVal() !== selectedText && selectedText !== '');
				var h = _hidden.slxVal(v);
				// trigger change event
				if (ischange) {
					_hidden.trigger('change');
					el.trigger('change');
				} else { that.close(); }
				return h;
			}
		};
		// get and set text
		that.text = function (v) {
			if (v === void 0) {
				// get text
				return el.slxVal();
			} else {
				// set text
				if (v === '') { that.value(''); }
				return el.slxVal(v);
			}
		};
		// get selected index
		that.selectedIndex = function () {
			return that.items.findIndex(function (i) {
				return _itemValue(i).toString() === that.value();
			});
		};
		// get selected item
		that.selectedItem = function () {
			var i = that.selectedIndex();
			return (i >= 0 && that.items.length > i) ? that.items[i] : null;
		};
		// select item by index or value
		that.select = function (i) {
			var item = i;
			if (typeof item === 'number') { item = that.items[i]; }
			else if (typeof item === 'string') { that.text(item); }
			that.value(_itemValue(item));
		};
		// get selected index from filtered options
		that.selectedFilteredIndex = function () {
			var f = _filtered || that.items;
			// find index
			return f.findIndex(function (i) {
				return _itemValue(i).toString() === that.value();
			});
		};
		// get selected item from filtered options
		that.selectedFilteredItem = function () {
			var f = _filtered || that.items;
			var i = that.selectedFilteredIndex();
			return (i >= 0 && f.length > 0) ? f[i] : null;
		};

		// prevent default behavior for defined keypress
		var _preventDefault = function (event) {
			var k = event.keyCode || event.which;
			// keypresses to prevent
			if ([13, 38, 40].indexOf(k) > -1) {
				event.preventDefault();
				return false;
			}
			return true;
		};

		// check for value property in item
		var _itemValue = function (item) {
			// ensure that the item exists
			if (item === null || item === void 0) {
				return '';
			}

			// get value (regardless of capitalization)
			return typeof item === 'string' ? item : item.Value || item.value || '';
		};

		// check for text property in item
		var _itemText = function (item) {
			// ensure that the item exists
			if (item === null || item === void 0) {
				return '';
			}

			// get text (regardless of capitalization)
			return typeof item === 'string' ? item : item.Text || item.text || '';
		};

		// local vars
		var _options, _blurTimeout = null, _changeTimeout = null, _autoChangeTimeout = null, _isScrolling = false, _selectedVal = null, _isAutoChange = false, _isClickSelect = false;
		// close options window
		that.close = function (options) {
			// close current options window
			that.container.removeClass('open');
			var opt = options || _options;
			_filtered = null;
			// clean up event listeners and trigger closed event
			if (opt !== void 0) { opt.off('click.slx').remove(); }
			el.off('click.slx').trigger('closed');
			x(document).off('click.slx');
			if (_blurTimeout !== null) { clearTimeout(_blurTimeout); }
			_options = void 0;
			el.closest('form').off(EVENTS.keydown);
			x(document).off(EVENTS.keydown);
		};

		// open options window
		that.open = function () {
			// open options
			that.container.addClass('open');
			x('.slx-autocomplete-container:not(#' + that.container.prop('id') + ') .slx-autocomplete-options').empty();
			_filtered = _filtered || that.items;

			// close if filtered options is empty
			if (_filtered.length === 0) {
				that.close();
				return;
			}
			// reset local var and rebuild options window
			_options = that.container.find('.slx-autocomplete-options');
			if (_options.length > 0) { _options.empty(); }
			// drop-down needs tabindex to maintain focus when within a modal
			else { that.container.append(_options = x('<UL/>').addClass('slx-autocomplete-options').attr({'aria-labelledby': _label.prop('id'), 'tabindex': '-1'})); }

			// set size
			if (that.dropDownHeight !== null) { _options.css('max-height', that.dropDownHeight); }
			var a = that.text(), b = a.toLowerCase(), c = a.toUpperCase(), d = b.length > 0 ? b[0].toUpperCase() + b.substring(1) : '';

			// add options from filtered list
			for (var i = 0; i < _filtered.length; i++) {
				var txt;
				var item = _filtered[i];
				// create list item for option
				var li = x('<LI/>');
				// add data prop identifier
				li.attr('data-val', _itemValue(item));
				// check for template
				if (that.template !== null) {
					item.Content = that.template;
					for (var p in item) {
						if (p === 'Content') { continue; }
						txt = x.htmlEncode(item[p]);
						// mark content that matches text input
						if (that.text().length > 0 && that.highlight) { txt = txt.mark(a).mark(b).mark(c).mark(d); }
						item.Content = item.Content.replaceAll('{' + p + '}', txt);
					}
					li.html(item.Content);
				} else {
					// mark content that matches text input
					txt = a.length > 0 && that.highlight ? x.htmlEncode(_itemText(item)).mark(a).mark(b).mark(c).mark(d) : x.htmlEncode(_itemText(item));
					li.html(txt);
				}
				// add click event
				li.on(EVENTS.click, function () {
					_isClickSelect = true;
					clearTimeout(_autoChangeTimeout);
					var selectedLi = x(this);
					that.value(selectedLi.data('val') || '');
					_selectedVal = null;
					that.close();
				});
				_options.append(li);
			}

			// add event listeners
			el.closest('form').off(EVENTS.keydown).on(EVENTS.keydown, _preventDefault);
			x(document).off(EVENTS.click).on(EVENTS.click, function () { x('.slx-autocomplete-options').each(function () { x(this).remove(); }); });
			x(document).off(EVENTS.keydown).on(EVENTS.keydown, _preventDefault);
			_options.off(EVENTS.click).on(EVENTS.click, function (event) { x(this).stopBubble(event); });
			_options.off(EVENTS.scroll).on(EVENTS.scroll, function () {
				_isScrolling = true;
				if (_options.data('timeout')) { clearTimeout(_options.data('timeout')); }
				_options.data('timeout', setTimeout(function () { _isScrolling = false; }, 150));
			});
			el.off(EVENTS.click).on(EVENTS.click, function (event) { x(this).stopBubble(event); }).trigger('open');
		};

		// search for options
		that.search = function (query, callback) {
			var params = x.extend({ query: query || '' }, this.searchParameters || {});
			// check for ajax service
			if (that.service !== null) {
				_filtered = null;
				// do ajax call for results
				x.ajax({
					url: that.service,
					data: JSON.stringify(params),
					dataType: 'JSON',
					cache: false,
					type: 'POST',
					processData: true,
					contentType: 'application/json',
					async: false,
					// success callback
					success: function (result) {
						that.items = result || [];
						// trigger search event
						el.trigger('search');
						if (typeof (callback) === 'function') { callback(that.items); }
					},
					// error callback
					error: function (err, textStatus) {
						console.error(err.status, textStatus);
					}
				});
			} else {
				// filter client-side option source
				_filtered = that.items.filter(function (a) {
					return typeof a === 'string' ? a.toLowerCase().startsWith(params.query.toLowerCase()) : _itemText(a).toString().toLowerCase().startsWith(params.query.toLowerCase()) || _itemValue(a).toString().toLowerCase() === params.query.toLowerCase();
				});
				// trigger search event
				el.trigger('search');
				if (typeof (callback) === 'function') { callback(_filtered); }
			}
		};

		var _btn = this.container.find('.slx-autocomplete-arrow');

		/* initialization */
		(function () {
			el.attr('onchange', null);

			// get control label
			if (_label.length === 0) { _label = x('label[for="' + el.prop('name') + '"]').attr('for', that.id); }
			if (_label.length > 0 && _label.prop('id').length === 0) { _label.attr('id', that.id + '_label'); }

			// check for input-group
			if (that.container.hasClass('input-group')) {
				that.container.prop('id', that.id + '_container').attr('data-target', that.selector).addClass('slx-autocomplete-container');
			}

			// get container or wrap control in a container
			if (that.container.length === 0) {
				el.wrap(x('<DIV/>').prop('id', that.id + '_container').attr('data-target', that.selector).addClass('slx-autocomplete-container'));
				that.container = x(that.selector + '_container');
			}

			// check for client-side drop-down control for source options
			if (el.prop('tagName') === 'SELECT') {
				// convert drop-down into text input field
				_hidden = el;
				_hidden.attr('id', that.id + '_value').hide();
				_hidden.after(that._element = el = x('<INPUT/>').attr('type', 'text').attr('id', that.id).attr('name', that.id));
				el.prop('disabled', _hidden.prop('disabled')).attr('placeholder', that.placeholder);

				// migrate CSS classes
				x.each(_hidden.attr('class').split(/\s+/), function (i, a) {
					_hidden.removeClass(a);
					el.addClass(a);
				});

				// create local item array from drop-down options
				that.items.length = 0;
				_hidden.find('option').each(function () {
					var opt = x(this);
					var item = { Value: opt.val(), Text: opt.slxText() };

					// extend item according to data-* attributes
					var data = opt.data();
					for (var p in data) {
						item[p] = data[p];
					}

					that.items.push(item);
					// determine default selected item
					if (opt.prop('selected')) {
						el.data('original-val', opt.slxText());
						el.slxVal(opt.text());
					}
				});

				_hidden.data('element', el);
			}

			// add SLX class and set original val
			if (!el.hasClass('slx-autocomplete')) { el.addClass('slx-autocomplete'); }
			if (!el.data('original-val')) el.data('original-val', el.slxVal());
			el.attr('autocomplete', 'off');

			// add hidden value field if needed
			if (_hidden.length === 0) {
				el.before(_hidden = x('<INPUT/>').attr('id', that.id + '_value').attr('type', 'hidden').attr('name', that.id + '_value'));
				if (el.data('value') !== void 0) { _hidden.val(el.data('value')); }
				else if (el.data('value') === void 0 && el.slxVal() && that.items.length) {
					var v = el.slxVal();
					el.slxVal('');
					
					// find matching item of current value regardless of data type
					var idx = that.items.findIndex(function(i) {
						return _itemValue(i) == v || _itemText(i) == v;
					});

					// set selected item value and text if existing item matches current value
					if (idx > -1) {
						var item = that.items[idx];
						_hidden.slxVal(_itemValue(item));
						el.slxVal(_itemText(item));
					}
				}
				_hidden.data('original-val', _hidden.slxVal());
			}

			// add pull-down options button if needed
			if (_btn.length === 0) {
				_btn = x('<BUTTON/>').attr({
					type: 'button',
					'aria-haspopup': 'true',
					'aria-expanded': 'false',
					tabindex: '-1'
				}).addClass('slx-autocomplete-arrow');
				_btn.append(x('<SPAN/>').addClass('caret').attr('aria-hidden', 'true'));
				el.after(_btn);

				// wrap button if is in input-group
				if (that.container.hasClass('input-group')) {
					_btn.addClass('btn');
					_btn.wrap(x('<DIV/>').addClass('input-group-btn').addClass('slx-autocomplete-group-btn'));
				}
			}
			_btn.prop('disabled', el.prop('disabled'));
			
			// accesibility
			if (!_btn.attr('aria-label')) {
				var labelText = _label.aria('label') || _label.text().replace(/"/g, '');
				_btn.attr('aria-label', 'Choose ' + labelText);
			}

			// show/hide pull-down button
			if (that.showArrow === false) { _btn.hide(); }
			else if (that.container.is(':visible')) {
				// calculate button position
				var c = that.container.width(), t = el.outerWidth();
				if (t - 2 <= c) { _btn.css('right', (c - t) + 'px'); }
				else if (t - 2 > c) { _btn.css('right', '-' + Math.round(t - c) + 'px'); }
			}

			// trigger render event when finished rendering
			setTimeout(function () {
				el.trigger('render');
				_hidden.trigger('render');
			}, 0);
		})();

		/* events */
		(function () {
			// add hidden field change event
			_hidden.off(EVENTS.change).on(EVENTS.change, function () {
				var item = that.selectedItem() || null;
				if (item === null && !that.requireMatch) {
					item = _hidden.slxVal();
				}
				that.text(_itemText(item));
			});
			// add input element change event
			el.off(EVENTS.change).on(EVENTS.change, function (event) {
				// prevent default if is autochange event
				if (_isAutoChange) {
					event.preventDefault();
					_isAutoChange = false;
					return;
				}

				// selected item
				var item = null;

				// ensure options exists
				if (_options !== void 0) {
					_selectedVal = _options.children('.active').data('val') || null;
					clearTimeout(_changeTimeout);
					// change associated fields on change
					_changeTimeout = setTimeout(function () {
						if (that.isScrolling()) { return; }
						// set selected value
						if (_selectedVal !== null) {
							_hidden.slxVal(_selectedVal);
							item = that.selectedItem();
							el.slxVal(_itemText(item));
						}
						// trigger change event
						if (typeof that.onChange === 'function') {
							that.onChange.call(el[0], event);
						}
						that.close();
					}, 250);
					if (_selectedVal !== null) { return; }
				}

				// check for element in focus
				setTimeout(function() {
					if (!_isClickSelect && !el.is(':focus') && that.container.find(':focus').length === 0 && !that.isScrolling()) {
						// auto change handler
						_autoChangeTimeout = setTimeout(function () {

							// get first matching item
							item = that.text().length > 0 ?
								that.items.find(function (i) {
									var lt = that.text().toLowerCase();
									var li;
									if (typeof i === 'string') {
										li = i.toLowerCase();
									} else {
										li = _itemText(i).toLowerCase();
									}
									return that.requireMatch ? li.startsWith(lt) : li === lt;
								}) || null : null;

							if (item !== null) {
								// set selected value
								that.value(_itemValue(item));
								that.text(_itemText(item));
							} else if (that.requireMatch) {
								// clear selected value
								item = that.items.length ? that.items.find(function (i) {
									var li = typeof i === 'string' ? i : _itemValue(i);
									return li === '';
								}) || null : null;
		
								that.text(item ? _itemText(item) : '');
								that.value('');
							} else {
								// set value equal to text when match is not required
								that.value(that.text());
							}
							// close once selected
							clearTimeout(_changeTimeout);
							that.close();
							if (typeof that.onChange === 'function') {
								that.onChange.call(that._element, event);
							}
						}, 200);
					}
					// when previous action was a selection from the drop-down and now the value is empty
					else if (_isClickSelect && !_hidden.slxVal()) {
						var t = '';
						if (that.requireMatch) {
							item = that.items.length ? that.items.find(function (i) {
								var li = typeof i === 'string' ? i : _itemValue(i);
								return li === '';
							}) || null : null;
							t = item ? _itemText(item) : t;
						}

						that.text(t);
						that.value('');
					}
	
					// reset the click event flag
					_isClickSelect = false;
				}, 5);
			});
			// container key press event
			that.container.off(EVENTS.keyup).on(EVENTS.keyup, function (event) {
				var k = event.keyCode || event.which;
				var opt, top;
				/* escape key */
				if (k === 27) { that.close(); }
				/* up arrow */
				else if (k === 38) {
					if (_options !== void 0 && _options.length > 0) {
						// move current active child to previous child 
						opt = _options.children('li.active').removeClass('active').prev();
						// prevent action if already at the top
						if (opt.length === 0) { return; }
						// set focused item
						opt.focus().addClass('active');

						// scroll to active item
						top = opt.is(':first-child') ? -opt.outerHeight() : Math.round(opt.position().top);
						if (top <= 0) {
							_options.scrollTop(_options.scrollTop() + top);
							top = Math.round(_options.scrollTop());
						}
					} else {
						// filter options
						that.search(that.text(), that.open);
					}
				}
				/* down arrow */
				else if (k === 40) {
					if (_options !== void 0 && _options.length > 0) {
						// show options if closed
						if (!_options.is(':visible')) { _options.show(); }

						// current active child
						opt = _options.children('li.active');

						// set first child active if none currently
						if (opt.length === 0) {
							opt = _options.children(':first-child').addClass('active');
							return;
						} else if (opt.is(':last-child')) {
							// prevent action if already at the bottom
							return;
						}

						// move to next item
						opt = opt.removeClass('active').next();
						opt.addClass('active');
						opt.focus().addClass('active');

						// scroll to active item
						top = Math.round(opt.position().top);
						if (top + opt.outerHeight() > _options.outerHeight()) { _options.scrollTop(_options.scrollTop() - (_options.outerHeight() - (top)) + opt.outerHeight()); }
						else if (top <= 0) { return; }
					} else {
						// filter options
						that.search(that.text(), that.open);
					}
				}
				/* enter key */
				else if (k === 13) {
					// don't bubble up to parent element events
					that.container.stopBubble(event);
					if (_options !== void 0 && _options.length > 0) {
						// current active element
						var active = _options.children('.active');
						if (active.length === 0) { return; }
						// update selected value
						_isClickSelect = true;
						_hidden.slxVal('');
						that.value(active.data('val'));
						_isAutoChange = true;
						_selectedVal = null;
						that.close(_options);
						el.blur();
					}
				}
			});

			// element key press event
			var _keyInterval = null, _keyTimer = 0;
			el.off(EVENTS.keyup).on(EVENTS.keyup, function (event) {
				// prevent behavior for defined keys
				if (!_preventDefault(event)) { return; }
				// close the drop-down when input is cleared out
				else if (that.text().trim().length === 0) {
					that.close();
					return;
				}
				// clear old value when new text is being entered without triggering change event
				else { _hidden.slxVal(''); }
				// set key stroke search delay timer
				_keyTimer = that.service !== null ? 10 : 0;
				if (_keyInterval === null) {
					_keyInterval = setInterval(function () {
						if (_keyTimer <= 0) {
							// clean up timers
							clearInterval(_keyInterval);
							_keyInterval = null;
							_keyTimer = 0;
							// do search if value not empty
							if (that.text().trim().length > 0) {
								that.search(that.text(), function () {
									if (el.is(':focus')) { that.open(); }
								});
							} else { that.close(); }
						}
						_keyTimer--;
					}, 40);
				}
			});
			// pull-down options button click event
			_btn.off(EVENTS.click).on(EVENTS.click, function (event) {
				_filtered = null;
				_btn.stopBubble(event);
				_options = that.container.find('.slx-autocomplete-options');
				// check for options window opened
				if (_options.length > 0) {
					// set value by currently selected and close
					var active = _options.children('.active');
					if (active.length === 0) {
						that.close(_options);
						return;
					}
					that.value(active.data('val'));
					that.close(_options);
				} else {
					// open options and do search
					that.search('', that.open);
				}
			});
			// container event for losing focus
			that.container.off(EVENTS.focusout).on(EVENTS.focusout, function (event) {
				setTimeout(function() {
					if (that.container.find(':focus').length === 0) {
						// close open options window when losing focus
						_blurTimeout = setTimeout(function () {
							if (!_btn.is(':focus') && !that.isScrolling()) {
								if ((!that.requireMatch && that.selectedItem() && that.text() !== _itemText(that.selectedItem()))
									|| (that.selectedItem() &&  that.value() !== _itemValue(that.selectedItem()))) {
									el.trigger('change');
								} else if (that.requireMatch && that.selectedItem() && that.value() === _itemValue(that.selectedItem()) && that.text() !== _itemText(that.selectedItem())) {
									that.text(_itemText(that.selectedItem()));
								}
								that.close(_options);
							}
						}, 200);
					}
				}, 5);
			});
			if (that.showArrow !== false) {
				// window resize event
				x(global).off(EVENTS.resize + that.id).on(EVENTS.resize + that.id, function (event) {
					// reposition button on window resize
					var c = that.container.width(), t = el.outerWidth();
					if (t - 2 <= c) { _btn.css('right', (c - t) + 'px'); }
					else if (t - 2 > c) { _btn.css('right', '-' + Math.round(t - c) + 'px'); }
				});
			}
		})();

		// add scrolling flag
		that.isScrolling = function () { return _isScrolling; };

		// register control w/ element
		el[0].slxAutoComplete = this;
		el[0].isSlxControl = true;

		return el;
	};
	// update constructor
	x.slx.autocomplete.prototype = Object.create(x.slx.base.prototype);
	x.slx.autocomplete.prototype.constructor = x.slx.autocomplete;

	/* jQuery extenders */
	x.slx.extend({
		// add control init extension
		slxAutoComplete: function () {
			var slx = this.slxControl('slxAutoComplete', arguments) || new x.slx.autocomplete(this, arguments);
			if (arguments.length > 0) {
				var arg = arguments[0], args = Array.prototype.slice.call(arguments, 1);
				if (typeof arg === 'string' && slx.hasOwnProperty(arg)) { return typeof (slx[arg]) === 'function' ? slx[arg].apply(slx, args) : slx[arg]; }
				else if (typeof arg !== 'string') { x.extend(slx, arg); }
			}
			return this.data('element') || this;
		}
	});
	
	// register control
	x.slx.register('slxAutoComplete', x.slx.slxAutoComplete);

	// initialize all controls by CSS class
	x(function () { x('.slx-autocomplete').each(function () { x(this).slxAutoComplete(); }); });

	return x;
})(window || this);
